// Efek suara mini game disintesis WebAudio (tanpa file aset). Preferensi di localStorage `jawsel_sfx` ("0" = bisu).
const KEY = "jawsel_sfx";
let ctx = null;
export const suaraAktif = () => localStorage.getItem(KEY) !== "0";
export const setSuara = (on) => localStorage.setItem(KEY, on ? "1" : "0");

function ac() {
  if (!ctx) { const C = window.AudioContext || window.webkitAudioContext; if (!C) return null; ctx = new C(); }
  if (ctx.state === "suspended") ctx.resume();
  return ctx;
}
function noise(c, durasi) {
  const buf = c.createBuffer(1, Math.ceil(c.sampleRate * durasi), c.sampleRate), d = buf.getChannelData(0);
  for (let i = 0; i < d.length; i++) d[i] = (Math.random() * 2 - 1) * (1 - i / d.length);
  const src = c.createBufferSource(); src.buffer = buf; return src;
}

export const sfx = {
  // "tak": kapak menancap di kayu — ketukan kayu rendah + sedikit derak
  tak() {
    if (!suaraAktif()) return; const c = ac(); if (!c) return;
    const t = c.currentTime, g = c.createGain(); g.connect(c.destination);
    g.gain.setValueAtTime(0.0001, t); g.gain.exponentialRampToValueAtTime(0.5, t + 0.004); g.gain.exponentialRampToValueAtTime(0.0001, t + 0.14);
    const o = c.createOscillator(); o.type = "triangle"; o.frequency.setValueAtTime(220, t); o.frequency.exponentialRampToValueAtTime(70, t + 0.12); o.connect(g); o.start(t); o.stop(t + 0.15);
    const n = noise(c, 0.06), f = c.createBiquadFilter(); f.type = "lowpass"; f.frequency.value = 1400; const ng = c.createGain(); ng.gain.value = 0.35;
    n.connect(f); f.connect(ng); ng.connect(c.destination); n.start(t); n.stop(t + 0.06);
  },
  // "trang": kapak kena kapak — dentang logam (dua nada tak harmonis) + desis
  trang() {
    if (!suaraAktif()) return; const c = ac(); if (!c) return;
    const t = c.currentTime, g = c.createGain(); g.connect(c.destination);
    g.gain.setValueAtTime(0.0001, t); g.gain.exponentialRampToValueAtTime(0.35, t + 0.003); g.gain.exponentialRampToValueAtTime(0.0001, t + 0.5);
    for (const [fq, tp] of [[2350, "square"], [3170, "triangle"], [1480, "sine"]]) {
      const o = c.createOscillator(); o.type = tp; o.frequency.setValueAtTime(fq, t); o.frequency.exponentialRampToValueAtTime(fq * 0.92, t + 0.45);
      const og = c.createGain(); og.gain.value = 0.3; o.connect(og); og.connect(g); o.start(t); o.stop(t + 0.5);
    }
    const n = noise(c, 0.09), f = c.createBiquadFilter(); f.type = "highpass"; f.frequency.value = 3000; const ng = c.createGain(); ng.gain.value = 0.25;
    n.connect(f); f.connect(ng); ng.connect(c.destination); n.start(t); n.stop(t + 0.09);
  },
  // "krak": gelondong terbelah — derak kayu patah
  krak() {
    if (!suaraAktif()) return; const c = ac(); if (!c) return;
    const t = c.currentTime;
    const n = noise(c, 0.35), f = c.createBiquadFilter(); f.type = "bandpass"; f.frequency.setValueAtTime(900, t); f.frequency.exponentialRampToValueAtTime(250, t + 0.3); f.Q.value = 0.8;
    const g = c.createGain(); g.gain.setValueAtTime(0.6, t); g.gain.exponentialRampToValueAtTime(0.0001, t + 0.35);
    n.connect(f); f.connect(g); g.connect(c.destination); n.start(t); n.stop(t + 0.35);
    const o = c.createOscillator(); o.type = "sawtooth"; o.frequency.setValueAtTime(140, t); o.frequency.exponentialRampToValueAtTime(45, t + 0.3);
    const og = c.createGain(); og.gain.setValueAtTime(0.25, t); og.gain.exponentialRampToValueAtTime(0.0001, t + 0.3); o.connect(og); og.connect(c.destination); o.start(t); o.stop(t + 0.3);
  },
  // "ting": penumpang naik — lonceng dua nada cerah
  ting() {
    if (!suaraAktif()) return; const c = ac(); if (!c) return;
    const t = c.currentTime;
    [[880, 0], [1320, 0.07]].forEach(([fq, d]) => {
      const o = c.createOscillator(), g = c.createGain(); o.type = "sine"; o.frequency.value = fq;
      g.gain.setValueAtTime(0.0001, t + d); g.gain.exponentialRampToValueAtTime(0.35, t + d + 0.01); g.gain.exponentialRampToValueAtTime(0.0001, t + d + 0.28);
      o.connect(g); g.connect(c.destination); o.start(t + d); o.stop(t + d + 0.3);
    });
  },
  // "klakson": klakson bus dua nada (telolet pendek)
  klakson() {
    if (!suaraAktif()) return; const c = ac(); if (!c) return;
    const t = c.currentTime, f = c.createBiquadFilter(); f.type = "lowpass"; f.frequency.value = 1800;
    const g = c.createGain(); g.gain.setValueAtTime(0.0001, t); g.gain.exponentialRampToValueAtTime(0.28, t + 0.02); g.gain.setValueAtTime(0.28, t + 0.22); g.gain.exponentialRampToValueAtTime(0.0001, t + 0.34);
    f.connect(g); g.connect(c.destination);
    for (const fq of [330, 415, 494]) { const o = c.createOscillator(); o.type = "sawtooth"; o.frequency.value = fq; o.connect(f); o.start(t); o.stop(t + 0.35); }
  },
  // "decit": ban berdecit saat menikung — desis bandpass menurun
  decit() {
    if (!suaraAktif()) return; const c = ac(); if (!c) return;
    const t = c.currentTime, n = noise(c, 0.2), f = c.createBiquadFilter(); f.type = "bandpass"; f.Q.value = 6;
    f.frequency.setValueAtTime(2600, t); f.frequency.exponentialRampToValueAtTime(1500, t + 0.18);
    const g = c.createGain(); g.gain.setValueAtTime(0.22, t); g.gain.exponentialRampToValueAtTime(0.0001, t + 0.2);
    n.connect(f); f.connect(g); g.connect(c.destination); n.start(t); n.stop(t + 0.2);
  },
  // "brak": bus nyungsep — dentum rendah + gemuruh dedaunan
  brak() {
    if (!suaraAktif()) return; const c = ac(); if (!c) return;
    const t = c.currentTime;
    const o = c.createOscillator(); o.type = "sine"; o.frequency.setValueAtTime(120, t); o.frequency.exponentialRampToValueAtTime(30, t + 0.4);
    const og = c.createGain(); og.gain.setValueAtTime(0.7, t); og.gain.exponentialRampToValueAtTime(0.0001, t + 0.45); o.connect(og); og.connect(c.destination); o.start(t); o.stop(t + 0.45);
    const n = noise(c, 0.5), f = c.createBiquadFilter(); f.type = "lowpass"; f.frequency.setValueAtTime(1800, t); f.frequency.exponentialRampToValueAtTime(300, t + 0.45);
    const g = c.createGain(); g.gain.setValueAtTime(0.5, t); g.gain.exponentialRampToValueAtTime(0.0001, t + 0.5);
    n.connect(f); f.connect(g); g.connect(c.destination); n.start(t); n.stop(t + 0.5);
  },
};
